<template>
    <div>
        <div>Api 1 : {{apiStatus1}}</div>
        <div>Api 2 : {{apiStatus2}}</div>
        <div>Api 3 : {{apiStatus3}}</div>
    </div>
</template>
<script>
import ApiForTextPromise from "../service/ApiForTestPromise.js";

export default {
    name: "PromiseChainExample",
    data: function() {
        return {
            apiStatus1: false,
            apiStatus2: false,
            apiStatus3: false,
        };
    },
    mounted: function() {
        this.connectApi();
    },
    methods: {
        connectApi: function() {
            this.apiGetBook(0).then((res) => {
                this.apiStatus1 = res.data;
                return this.apiGetBook(1);
            }).then((res) => {
                this.apiStatus2 = res.data
                return this.apiGetBook(2);
            }).then((res) => {
                this.apiStatus3 = res.data
            }).catch((err) => {
                console.log(err);
            });


        },
        apiGetBook: function(id) {
            return ApiForTextPromise.apiGetBook(id);
        },
    },
}
</script>
